import { useQuery } from 'react-query'
import { NestAPI } from '@marketing-milk/frontend'
import { AdCreative } from '@marketing-milk/interfaces'
import { PickerFile } from './useGooglePicker'
import {
  AIStudioGenerateResponse,
  AIStudioImportRequest,
  CopyGenerationRequest,
  CopyGenerationResponse,
  CopySuggestion,
  CopyPreviewResponse,
} from '@marketing-milk/interfaces'
import { toast } from 'react-toastify'

export const useAIStudio = (businessID: string) => {
  const generateAd = async (payload: {
    creativeIDs: number[]
    driveImageDataUrls?: string[]
    mode: string
    prompt: string
  }): Promise<AIStudioGenerateResponse> => {
    const response = await NestAPI.post<AIStudioGenerateResponse>(
      `businesses/${businessID}/ai-studio/generate`,
      payload
    )
    return response.data
  }

  const importAdImage = async (payload: AIStudioImportRequest): Promise<void> => {
    await NestAPI.post(`businesses/${businessID}/ai-studio/import-image`, payload)
    toast.success('Ad image created successfully!')
  }

  const importCreative = async (payload: AIStudioImportRequest): Promise<AdCreative> => {
    const response = await NestAPI.post<AdCreative>(
      `businesses/${businessID}/ai-studio/import`,
      payload
    )
    toast.success('Creative imported successfully!')
    return response.data
  }

  const generateCopy = async (payload: CopyGenerationRequest): Promise<CopyGenerationResponse> => {
    const response = await NestAPI.post<CopyGenerationResponse>(
      `businesses/${businessID}/ai-studio/generate-copy`,
      payload
    )
    return response.data
  }

  const generateCopyPreview = async (
    jobID: string,
    suggestion: CopySuggestion
  ): Promise<CopyPreviewResponse> => {
    const response = await NestAPI.post<CopyPreviewResponse>(
      `businesses/${businessID}/ai-studio/preview-copy`,
      {
        jobID,
        headline: suggestion.headline,
        description: suggestion.description,
        graphicText: suggestion.graphicText,
        primaryText: suggestion.primaryText,
        callToAction: suggestion.callToAction,
      }
    )
    return response.data
  }

  return { generateAd, importAdImage, importCreative, generateCopy, generateCopyPreview }
}

export const useBusinessFolderImages = (businessID: string) => {
  return useQuery<PickerFile[]>(
    ['ai-studio-business-folder-images', businessID],
    async () => {
      const response = await NestAPI.get<PickerFile[]>(
        `businesses/${businessID}/ai-studio/business-folder-images`
      )
      return response.data
    },
    { staleTime: 60_000 }
  )
}
